import React from "react";
import styled from "styled-components";
import Image from "react-bootstrap/Image";
import { startCase } from "lodash";

const Snnit = ({ data }) => {
  return (
    <Wrapper>
      <Image src="/cards/snnit.png" className="wrapper__background" />
      <div className="content">
        <div className="content__item content__image">
          <Image src={`data:image/png;base64, ${data?.picture}`} />
        </div>
        <div className="content__item content__number">
          {data?.id_number || ""}
        </div>
        <div className="content__item content__name">
          {(data?.first_name || "") + (data?.last_name || "")}
        </div>
        <div className="content__item content__gender">
          {startCase(data?.sex || data?.gender)}
        </div>
        <div className="content__item content__date-of-birth">
          {data?.date_of_birth || ""}
        </div>
        <div className="content__item content__serial">
          {data?.card_serial || ""}
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 290px;
  height: 181px;
  position: relative;
  img.wrapper__background {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .content {
    width: 100%;
    height: 100%;
    position: relative;
    &__item {
      color: #000;
      font-size: 6px;
      font-weight: 500;
      line-height: 7px;
      position: absolute;
    }
    &__image {
      top: 47px;
      right: 6px;
      width: 88px;
      height: 88px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    &__number {
      top: 76px;
      left: 89px;
      font-size: 11px;
      font-weight: bold;
      line-height: 13px;
    }
    &__serial {
      left: 30px;
      bottom: 9px;
    }
    &__name {
      top: 137px;
      right: 10px;
      font-size: 7px;
      max-width: 56px;
      line-height: 8px;
      text-align: right;
    }
    &__gender {
      right: 10px;
      bottom: 15px;
    }
    &__date-of-birth {
      bottom: 9px;
      right: 10px;
    }
  }
`;

export default Snnit;
